export const reportError = (error, extra) => {
  console.error({ error, extra }); // eslint-disable-line no-console
};
